import { useEffect, useState, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function VerificarEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState("loading");
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    if (!token) { setStatus("error"); return; }
    api.post("/auth/verify-email", { token })
      .then(() => setStatus("ok"))
      .catch(() => setStatus("error"));
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-bg p-6">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-xl border border-slate-100 p-8 sm:p-10 text-center">
        <Logo className="justify-center" />
        {status === "loading" && (
          <div className="mt-8"><Loader2 className="w-8 h-8 animate-spin text-brand-blue mx-auto" /><p className="mt-4 text-brand-muted">Verificando...</p></div>
        )}
        {status === "ok" && (
          <div className="mt-8">
            <div className="w-14 h-14 rounded-2xl bg-emerald-50 flex items-center justify-center mx-auto"><CheckCircle2 className="w-7 h-7 text-brand-green" /></div>
            <h1 className="mt-5 font-heading text-2xl font-black text-brand-ink">E-mail confirmado!</h1>
            <p className="mt-2 text-brand-muted text-sm">Sua conta está verificada. Aproveite o EDUCARTE.</p>
            <Link to="/dashboard"><Button className="mt-6 rounded-full bg-brand-blue hover:bg-blue-700" data-testid="verify-dashboard-btn">Ir para o painel</Button></Link>
          </div>
        )}
        {status === "error" && (
          <div className="mt-8">
            <div className="w-14 h-14 rounded-2xl bg-red-50 flex items-center justify-center mx-auto"><XCircle className="w-7 h-7 text-red-500" /></div>
            <h1 className="mt-5 font-heading text-2xl font-black text-brand-ink">Link inválido</h1>
            <p className="mt-2 text-brand-muted text-sm">O link de verificação é inválido ou expirou.</p>
            <Link to="/login"><Button className="mt-6 rounded-full bg-brand-blue hover:bg-blue-700">Voltar ao login</Button></Link>
          </div>
        )}
      </div>
    </div>
  );
}
